import './page-title.scss';

const PageTitle = ({ title }) => {
    return <h1 className="page-title-v2">{title}</h1>;
};

export default PageTitle;
